import { createAction } from 'redux-actions';

import {
  INITIALIZE_ALL_USAGES,
  INITIALIZE_SUBSCRIPTION_USAGE,
  SUBSCRIPTION_USAGE_FETCH,
  SUBSCRIPTION_USAGE_RECEIVE,
  ALL_USAGES_FETCH,
  ALL_USAGES_RECEIVE,
  USAGES_RECEIVE_ERROR,
} from './constants';

export const initializeAllUsages = createAction(INITIALIZE_ALL_USAGES, (id) => ({
  id,
}));

export const initializeSubscriptionUsage = createAction(INITIALIZE_SUBSCRIPTION_USAGE, (id) => ({
  id,
}));

export const fetchAllUsages = createAction(ALL_USAGES_FETCH, (id, startDate, endDate) => ({
  id,
  startDate,
  endDate,
}));

export const receiveAllUsages = createAction(ALL_USAGES_RECEIVE, (entities) => ({
  entities,
}));

export const receiveUsagesError = createAction(USAGES_RECEIVE_ERROR, () => ({
}));


export const fetchSubscriptionUsage = createAction(SUBSCRIPTION_USAGE_FETCH, (id, startDate, endDate) => ({
  id,
  startDate,
  endDate,
}));


export const receiveSubUsage = createAction(SUBSCRIPTION_USAGE_RECEIVE, (entities) => ({
  entities,
}));

